import { render } from "./Stats.vue?vue&type=template&id=4178fd76&scoped=true"
import script from "./Stats.vue?vue&type=script&lang=js"
export * from "./Stats.vue?vue&type=script&lang=js"

import "./Stats.vue?vue&type=style&index=0&id=4178fd76&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4178fd76"

export default script